// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { useCallback } from "react";
import { LogService } from "../../../../io/hyperify/core/LogService";
import { ClientDTO } from "../../../../io/hyperify/core/store/types/client/ClientDTO";
import { GET_MY_CLIENT_ROUTE } from "../../core/constants/route";

const LOG = LogService.createLogger( 'useNavigateToClient' );

/**
 * This hook creates a callback which uses navigate to navigate into client account view.
 */
export function useNavigateToClient (
    navigate : ((url: string) => void),
) {
    return useCallback(
        (client: ClientDTO) : void => {
            const clientId = client?.id;
            if (clientId) {
                LOG.debug(`Navigating to ${clientId}: `, client);
                navigate(GET_MY_CLIENT_ROUTE(clientId));
            } else {
                LOG.error(`No client ID provided: `, client);
            }
        },
        [
            navigate
        ]
    );
}
